import React from 'react';
import { Box, Typography, Chip } from '@mui/material';
import { motion } from 'framer-motion';

const ACCENT = '#2563EB';

const skillGroups = [
  { label: 'Languages', skills: ['Java', 'Python', 'Go', 'C/C++', 'Ruby', 'SQL', 'TypeScript'] },
  { label: 'Cloud & Systems', skills: ['AWS ECS/Fargate', 'EC2', 'AWS CDK/CloudFormation', 'Lambda', 'Docker', 'Linux', 'Networking', 'CloudWatch'] },
  { label: 'Data & ML', skills: ['Athena', 'DynamoDB', 'RAG', 'LLM Evaluation / Benchmarks', 'Agentic Systems', 'Model Context Protocol (MCP)'] },
];

function SkillBars() {
  return (
    <section id="skills" style={{ paddingTop: '80px' }}>
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.5 }}
      >
        <Typography variant="h4" component="h2" gutterBottom>
          Skills
        </Typography>
      </motion.div>

      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3, alignItems: 'flex-start' }}>
        {skillGroups.map((group, groupIndex) => (
          <motion.div
            key={group.label}
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.4, delay: groupIndex * 0.08 }}
            style={{ width: '100%' }}
          >
            <Typography
              variant="overline"
              sx={{ color: ACCENT, fontWeight: 600, letterSpacing: '0.1em', display: 'block', mb: 1 }}
            >
              {group.label}
            </Typography>
            <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1 }}>
              {group.skills.map((skill, idx) => (
                <motion.div
                  key={skill}
                  initial={{ opacity: 0, scale: 0.85 }}
                  whileInView={{ opacity: 1, scale: 1 }}
                  viewport={{ once: true }}
                  transition={{ duration: 0.3, delay: groupIndex * 0.08 + idx * 0.04 }}
                >
                  <Chip
                    label={skill}
                    variant="outlined"
                    sx={{
                      borderColor: ACCENT,
                      color: ACCENT,
                      fontWeight: 500,
                      '&:hover': {
                        backgroundColor: ACCENT,
                        color: 'white',
                      },
                      transition: 'background-color 0.2s, color 0.2s',
                    }}
                  />
                </motion.div>
              ))}
            </Box>
          </motion.div>
        ))}
      </Box>
    </section>
  );
}

export default SkillBars;
